import React from "react";
import PropTypes from "prop-types";

import { css } from "@oddcommon/utils";
import styles from "./QuoteSection.module.scss";

// Scale modifiers correspond to the breakpoints
const WORD_COUNT_BREAKPOINTS = [3, 5, 20, 40, 60];
const SCALE_MODIFIERS = [1.2, 1, 0.85, 0.75, 0.65];
const DEFAULT_SCALE = 1.45;

export default function QuoteSection({
  children,
  attribution: { name, title } = {},
  className,
  ...props
}) {
  const wordCount = children.trim().split(" ").length;
  let quoteScale = DEFAULT_SCALE;
  WORD_COUNT_BREAKPOINTS.forEach((breakpoint, index) => {
    if (wordCount >= breakpoint) {
      quoteScale = SCALE_MODIFIERS[index];
    }
  });
  return (
    <section className={css(styles.base, className)} {...props}>
      <figure>
        <blockquote>
          <div className={styles.quoteContent} style={{ fontSize: `${quoteScale}em` }}>
            {children}
          </div>
        </blockquote>
        <figcaption>
          <span className={styles.dash}>&mdash;</span>
          {name && (
            <div className={styles.attribution}>
              <span className={styles.name}>{name}</span>
              {title && <span className={styles.title}>{title}</span>}
            </div>
          )}
        </figcaption>
      </figure>
    </section>
  );
}

QuoteSection.propTypes = {
  children: PropTypes.node.isRequired,
  attribution: PropTypes.shape({
    name: PropTypes.node,
    title: PropTypes.node,
  }),
};
